import { Actions, createEffect, ofType } from "@ngrx/effects";
import { AuthActions } from "./auth.actions";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { AuthService } from "./auth.service";
import { AuthApiLoginResponse } from "./auth-api.types";
import { HttpClient } from "@angular/common/http";
import { Store } from "@ngrx/store";
import {
  catchError,
  concatMap,
  filter,
  map,
  switchMap,
  take,
  tap,
  withLatestFrom,
} from "rxjs/operators";
import { selectCurrentSite, selectCurrentUser } from "./auth.selectors";
import { SiteStorageService } from "./services/site-storage.service";
import { EMPTY, from, of } from "rxjs";
import { AuthUser } from "./models/auth-user.model";
import { AuthSite } from "./models/auth-logspace-locator.model";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { SitePickerDialogService } from "../../sitepicker-dialog/sitepicker-dialog.service";
import { AppInitResolverService } from "../services/app-init-resolver.service";
import { AuthPermissionList } from "./models/auth-permissions.model";
// import { tap } from "rxjs";

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private auth: AuthService,
    // private http: HttpClient,
    private router: Router,
    // private dialog: MatDialog,
    private store: Store,
    private siteStorage: SiteStorageService,
    // private appInitResolver: AppInitResolverService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  persistSiteEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          AuthActions.loginSuccess,
          AuthActions.updateSiteSuccess,
          AuthActions.loadCurrentUserSuccess,
        ),
        tap((action) => {
          let siteList: AuthSite[] = [];
          let selectedSiteId: string | null = null;
          let shouldCallApi = false;

          if (action.type === AuthActions.loginSuccess.type) {
            siteList = action.siteList || [action.site];
            selectedSiteId = action.site?.siteId ?? null;
            // Call API when auto-selecting a site on login (single site case)
            shouldCallApi = !!selectedSiteId;
          } else if (action.type === AuthActions.loadCurrentUserSuccess.type) {
            siteList = action.siteList || [];
            selectedSiteId = action.site?.siteId || null;
            // Don't call API here - the selection came FROM the API
            shouldCallApi = false;
          } else if (action.type === AuthActions.updateSiteSuccess.type) {
            const storeData = this.siteStorage.readSiteData();
            siteList = storeData?.sites || [];
            selectedSiteId = action.newSite.siteId ?? null;
            // Don't call API here - updateSiteEffect$ already calls it
            shouldCallApi = false;
          }

          // Persist to local storage
          this.siteStorage.storeSiteData(siteList, selectedSiteId);

          // Also persist to database via API for login auto-selection
          if (shouldCallApi && selectedSiteId) {
            this.auth.setSiteSelection(selectedSiteId).subscribe({
              error: (err) => console.error("Failed to persist site selection to API:", err),
            });
          }
        }),
      ),
    { dispatch: false },
  );
  // actions$.subscribe(action => {

  // 	if (action.type === AuthActions.getCurrentUser.type) {
  // 		console.log("getCurrentUserEffect");
  // 		// if (isPlatformBrowser(this.platformId)) {
  // 			auth.getCurrentUser().pipe(take(1), catchError(error => EMPTY)).subscribe({
  // 				next: (user: AuthApiLoginResponse | undefined)=> {
  // 					console.log("getCurrentUserEffect:", user);
  // 				},
  // 				error: (err: any) => { /* do nothing */ }
  // 			});
  // 		// }

  // 	} else if (action.type === AuthActions.login.type) {
  // 		const myAction = action as ReturnType<typeof AuthActions.login>;
  // 		console.log("loginEffect:", myAction.user, myAction.site);
  // 	// } else if (action.type === AuthActions.testAction.type) {
  // 	// 	console.log("testActionEffect:");
  // 	// 	if (isPlatformBrowser(this.platformId)) {
  // 	// 		console.log('Running on the browser');
  // 	// 		http.get<AuthApiLoginResponse | ApiErrorResponse>("/api/v1/wassup/").pipe(take(1)).subscribe({
  // 	// 			next: (data: any) => {
  // 	// 				console.log("testActionEffect:2:", data);
  // 	// 			},
  // 	// 			error: (err: any) => {
  // 	// 				console.log("testActionEffect:3:", err);
  // 	// 			}
  // 	// 		});
  // 	// 	} else if (isPlatformServer(this.platformId)) {
  // 	// 		http.get<AuthApiLoginResponse | ApiErrorResponse>("http://labida.lcl:8080/api/v1/wassup/").pipe(take(1)).subscribe({
  // 	// 			next: (data: any) => {
  // 	// 				console.log("testActionEffect:2:", data);
  // 	// 			},
  // 	// 			error: (err: any) => {
  // 	// 				console.log("testActionEffect:3:", err);
  // 	// 			}
  // 	// 		});
  // 	// 	}
  // 	}
  // });

  // getCurrentUserEffect$ = createEffect(() => {
  // 		return this.actions$.pipe(
  // 			ofType(AuthActions.getCurrentUser),
  // 			tap(() => {
  // 				console.log("getCurrentUserEffect");
  // 			})

  // 		)
  // 	},
  // 	{ functional: true}
  // );
  // }

  // getCurrentUserEffect$ = createEffect(() => {
  // 	return this.actions$.pipe(
  // 		ofType(AuthActions.getCurrentUser),
  // 		switchMap(() => this.auth.getCurrentUser()
  // 			.pipe(
  // 				tap(resp => { console.log("getCurrentUser resp:", resp); }),
  // 				switchMap((resp: AuthApiLoginResponse | undefined) => {
  // 					if (!resp) {
  // 						return of(AuthActions.getCurrentUserFailure({error: "No user found"}));
  // 					}
  // 					const user = {userId: resp.data.userId, firstName: resp.data.firstName, lastName: resp.data.lastName} as AuthUser;
  // 					const site = {
  // 						siteId: resp.data.dSiteId,
  // 						siteName: resp.data.dSiteId,
  // 						subsiteId: resp.data.dLocatorId,
  // 						subsiteName: resp.data.dSiteName
  // 					} as AuthSite;
  // 					return this.auth.getPermissions(site.siteId ?? "", user.userId ?? "").pipe(
  // 						tap(permissions => { console.log("getCurrentUser:", permissions.data); }),
  // 						map(({data}) => AuthActions.getCurrentUserSuccess({user, site, permissions: data})),
  // 						catchError((error) => of(AuthActions.getCurrentUserFailure({error})))
  // 					);
  // 				}),
  // 				catchError(error => of(AuthActions.getCurrentUserFailure({error})))
  // 			)
  // 		)
  // 	);
  // });

  // getCurrentUserSuccessEffect$ = createEffect(() => {
  // 	return this.actions$.pipe(
  // 		ofType(AuthActions.getCurrentUserSuccess),
  // 		tap(() => {
  // 			this.router.navigate(["/"]);
  // 		})
  // 	);
  // }, { dispatch: false });

  loginEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.login),
      switchMap(({ bidaId, password }) =>
        this.auth.login(bidaId, password).pipe(
          map((resp: AuthApiLoginResponse) => {
            const user = {
              userId: resp.data.userId,
              firstName: resp.data.firstName,
              lastName: resp.data.lastName,
              username: resp.data.username,
              displayName: resp.data.displayName,
              email: resp.data.email,
              imageFileName: resp.data.imageFileName,
            } as AuthUser;

            const sites = resp.data.sites.map(
              (apiSite) =>
                ({
                  siteId: apiSite.siteId,
                  siteName: apiSite.siteName,
                  siteType: apiSite.siteType,
                  siteAddress: apiSite.siteAddress,
                  userRoleId: apiSite.userRoleId,
                  userRoleName: apiSite.userRoleName,
                  status: apiSite.status,
                  isParent: apiSite.isParent,
                  parentSiteId: apiSite.parentSiteId,
                }) as AuthSite,
            );

            if (sites.length === 1) {
              return AuthActions.loginSuccess({
                user,
                site: sites[0],
                siteList: sites,
              });
            } else if (sites.length === 0) {
              return AuthActions.loginSuccess({
                user,
                site: null,
                siteList: sites,
              });
            }
            return AuthActions.loginSuccess({
              user,
              site: null,
              siteList: sites,
            });
          }),
          catchError((error) => {
            let errorMessage = "Login failed. Please check your credentials.";

            // Try to extract error message from API response
            if (error.error && error.error.error && error.error.error.message) {
              // API error response format: { error: { code: number, message: string } }
              errorMessage = error.error.error.message;
            } else if (error.status === 401) {
              errorMessage =
                "Invalid credentials. Please check your BIDAPass ID and password.";
            } else if (error.status === 500) {
              errorMessage =
                "Server error. Please try again later or contact support.";
            } else if (error.status === 0) {
              errorMessage =
                "Unable to connect to server. Please check your internet connection.";
            }

            return of(
              AuthActions.loginFailure({ error: { message: errorMessage } }),
            );
          }),
        ),
      ),
    );
  });

  // Load permissions immediately when auto-selecting a site on login (single-site users)
  // This prevents the race condition where the menu renders before permissions are loaded
  loadPermissionsAfterLoginEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.loginSuccess),
      filter((action) => action.site !== null),
      map((action) =>
        AuthActions.updateSite({
          user: action.user,
          newSite: action.site!,
        }),
      ),
    );
  });

  logoutEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.logout),
      switchMap(() =>
        this.auth.logout().pipe(
          map(() => AuthActions.logoutSuccess()),
          catchError((error) => of(AuthActions.logoutFailure({ error }))),
        ),
      ),
    );
  });

  logoutSuccessEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AuthActions.logoutSuccess),
        tap(() => {
          // Clear site data from localStorage to prevent data leaking to next user
          this.siteStorage.clearSiteData();
          this.router.navigate(["/login"]);
        }),
      );
    },
    { dispatch: false },
  );

  updateSiteEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.updateSite),
      switchMap(({ user, newSite }) => {
        if (!newSite) {
          return of(
            AuthActions.updateSiteFailure({
              error: { message: "No site provided for selection" },
            }),
          );
        }

        // First, save site selection to database via API
        return this.auth.setSiteSelection(newSite.siteId).pipe(
          // Then fetch permissions for the selected site
          switchMap(() =>
            this.auth.getPermissions(newSite.siteId, user.userId).pipe(
              map(({ data }: { data: AuthPermissionList }) =>
                AuthActions.updateSiteSuccess({
                  newSite: newSite,
                  permissions: data,
                }),
              ),
            ),
          ),
          catchError((error) => {
            let errorMessage = "Failed to load site permissions";

            if (error.error?.message) {
              errorMessage = error.error.message;
            } else if (error.status === 403) {
              errorMessage = "You do not have permission to access this site";
            } else if (error.status === 404) {
              errorMessage = "Site not found";
            }

            return of(
              AuthActions.updateSiteFailure({
                error: { message: errorMessage },
              }),
            );
          }),
        );
      }),
    );
  });

  updateSiteSuccessEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.updateSiteSuccess),
        tap(() => {
          const currentUrl = this.router.url;
          const urlTree = this.router.parseUrl(currentUrl);
          const returnUrl = urlTree.queryParams['returnUrl'];

          // Only redirect if:
          // 1. There's a returnUrl to go to, OR
          // 2. Currently on login/site-select page (user just completed site selection flow)
          if (returnUrl && returnUrl !== '/login') {
            this.router.navigateByUrl(returnUrl);
          } else if (currentUrl.startsWith('/login') || currentUrl.startsWith('/site-select')) {
            this.router.navigate(["/"]);
          }
          // Otherwise: preserve current URL (deep link case)
        }),
      ),
    { dispatch: false },
  );

  updateSiteFailureEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.updateSiteFailure),
        tap(({ error }) => {
          console.error("Site update failed:", error);
        }),
      ),
    { dispatch: false },
  );

  // Triggered by the auth interceptor on HTTP 403. Pulls the current user +
  // site from the store and re-asks the server for the permission list so
  // the menu can hide items the user no longer has access to. Silently
  // skipped if there's no user or no current site (nothing to refresh).
  refreshPermissionsEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.refreshPermissions),
      withLatestFrom(
        this.store.select(selectCurrentUser),
        this.store.select(selectCurrentSite),
      ),
      switchMap(([, user, site]) => {
        if (!user || !site || !site.siteId) {
          return EMPTY;
        }
        return this.auth.getPermissions(site.siteId, user.userId).pipe(
          map(({ data }: { data: AuthPermissionList }) =>
            AuthActions.refreshPermissionsSuccess({ permissions: data }),
          ),
          catchError((error) =>
            of(AuthActions.refreshPermissionsFailure({ error })),
          ),
        );
      }),
    ),
  );

  // siteSelectedEffect$ = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(AuthActions.siteSelected),
  //     switchMap(({ user, site, siteList }) => {
  //       if (!!site) {
  //         return from(
  //           this.auth.getPermissions(site?.siteId ?? "", user.userId ?? ""),
  //         ).pipe(
  //           map(({ data }: { data: AuthPermissionList }) =>
  //             AuthActions.loginSuccess({
  //               user,
  //               site,
  //               permissions: data,
  //               siteList: siteList,
  //             }),
  //           ),
  //           catchError((error) => {
  //             let errorMessage = "Login failed. Please check your credentials.";

  //             // Try to extract error message from API response
  //             if (
  //               error.error &&
  //               error.error.error &&
  //               error.error.error.message
  //             ) {
  //               errorMessage = error.error.error.message;
  //             } else if (error.status === 401) {
  //               errorMessage =
  //                 "Invalid credentials. Please check your BIDAPass ID and password.";
  //             } else if (error.status === 500) {
  //               errorMessage =
  //                 "Server error. Please try again later or contact support.";
  //             } else if (error.status === 0) {
  //               errorMessage =
  //                 "Unable to connect to server. Please check your internet connection.";
  //             }

  //             return of(
  //               AuthActions.loginFailure({ error: { message: errorMessage } }),
  //             );
  //           }),
  //         );
  //       } else {
  //         return of(
  //           AuthActions.loginFailure({ error: { message: "Invalid site" } }),
  //         );
  //       }
  //     }),
  //   );
  // });

  // loadCurrentUserSuccessEffect$ removed - was causing F5 refresh to redirect to home
  // On page refresh, we want to preserve the current route, not navigate away

  loadCurrentUserFailureEffect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AuthActions.loadCurrentUserFailure),
        tap(() => {
          this.router.navigate(["/login"]);
        }),
      );
    },
    { dispatch: false },
  );

  // loadCurrentUserService$ = createEffect(
  //   () => {
  //     return this.actions$.pipe(
  //       ofType(AuthActions.loadCurrentUser),
  //       switchMap(() => {
  //         return this.authApiService.getCurrentUser().pipe(
  //           map((user) => AuthActions.loadCurrentUserSuccess({ user })),
  //           catchError((error) => {
  //             return of(AuthActions.loadCurrentUserFailure({ error }));
  //           }),
  //         );
  //       }),
  //     );
  //   },
  //   { dispatch: false },
  // );
  navigateAfterAuthSuccess$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AuthActions.loginSuccess),
        tap((action) => {
          // Check for returnUrl from current URL's query params
          const urlTree = this.router.parseUrl(this.router.url);
          const returnUrl = urlTree.queryParams['returnUrl'];
          if (returnUrl && returnUrl !== '/login') {
            // Navigate to the originally requested URL
            this.router.navigateByUrl(returnUrl);
          } else {
            // Navigate to home after fresh login - the site picker service will handle
            // showing the appropriate dialog (site selection or no-site-access)
            this.router.navigate(["/"]);
          }
        }),
      );
    },
    { dispatch: false },
  );
}

function Effect(): (target: AuthEffects, propertyKey: "loginEffect$") => void {
  throw new Error("Function not implemented.");
}
